import { useState, useEffect, useRef } from 'react';
import './NewItemMenu.css';
import { useOpenItemsContext } from './context/OpenItemsContext';

function NewItemMenu({
  newQuest,
  newPersonOrOrg,
  newPlace,
  newMiscItem,
  newLogEntry,
  close
} : {
  newQuest: () => void,
  newPersonOrOrg: () => void,
  newPlace: () => void,
  newMiscItem: () => void,
  newLogEntry: () => void,
  close: (lastOpenedItemId: string|null) => void
}) {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const { selectedItemId, setSelectedItemId } = useOpenItemsContext();
  const [lastOpenedItemId] = useState<string|null>(selectedItemId);

  useEffect(() => {
    setSelectedItemId(null);
  }, [setSelectedItemId]);

  useEffect(() => {
    if (menuRef.current) {
      menuRef.current.focus();
    }
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      switch (selectedIndex) {
        case 0:
          newQuest();
          close(null);
          break;
        case 1:
          newPersonOrOrg();
          close(null);
          break;
        case 2:
          newPlace();
          close(null);
          break;
        case 3:
          newMiscItem();
          close(null);
          break;
        case 4:
          newLogEntry();
          close(null);
          break;
        case 5:
          close(null);
          break;
      }
      e.stopPropagation();
      e.preventDefault();
    } else if (e.key === 'Escape') {
      close(lastOpenedItemId);
      e.stopPropagation();
      e.preventDefault();
    } else if (e.key === 'ArrowDown') {
      setSelectedIndex((prevIndex) => Math.min(prevIndex + 1, 5));
      e.stopPropagation();
      e.preventDefault();
    } else if (e.key === 'ArrowUp') {
      setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
      e.stopPropagation();
      e.preventDefault();
    } else if (e.key === 'q' || e.key === 'Q') {
      newQuest();
      close(null);
      e.stopPropagation();
      e.preventDefault();
    } else if (e.key === 'o' || e.key === 'O') {
      newPersonOrOrg();
      close(null);
      e.stopPropagation();
      e.preventDefault();
    } else if (e.key === 'p' || e.key === 'P') {
      newPlace();
      close(null);
      e.stopPropagation();
      e.preventDefault();
    } else if (e.key === 'm' || e.key === 'M') {
      newMiscItem();
      close(null);
      e.stopPropagation();
      e.preventDefault();
    } else if (e.key === 'l' || e.key === 'L') {
      newLogEntry();
      close(null);
      e.stopPropagation();
      e.preventDefault();
    }
  };

  return <div className="newitemmenubackdrop" onClick={() => close(lastOpenedItemId)}>
    <div
      className="newitemmenu"
      onClick={(e) => e.stopPropagation()}
      tabIndex={-1}
      ref={menuRef}
      onKeyDown={handleKeyDown}
    >
      <div className="newitemmenutitle">Create new item:</div>
      <div className="newitemmenuoptions">
        <div className={"newitemmenuoption quest " + (selectedIndex === 0 ? "selected" : "")} onClick={() => { newQuest(); close(null); }} onMouseEnter={() => setSelectedIndex(0)}><span className="hotkey">Q</span>uest</div>
        <div className={"newitemmenuoption personororg " + (selectedIndex === 1 ? "selected" : "")} onClick={() => { newPersonOrOrg(); close(null); }} onMouseEnter={() => setSelectedIndex(1)}>Person <span className="hotkey">o</span>r Group</div>
        <div className={"newitemmenuoption place " + (selectedIndex === 2 ? "selected" : "")} onClick={() => { newPlace(); close(null); }} onMouseEnter={() => setSelectedIndex(2)}><span className="hotkey">P</span>lace</div>
        <div className={"newitemmenuoption miscitem " + (selectedIndex === 3 ? "selected" : "")} onClick={() => { newMiscItem(); close(null); }} onMouseEnter={() => setSelectedIndex(3)}><span className="hotkey">M</span>iscellaneous Item</div>
        <div className={"newitemmenuoption logentry " + (selectedIndex === 4 ? "selected" : "")} onClick={() => { newLogEntry(); close(null); }} onMouseEnter={() => setSelectedIndex(4)}><span className="hotkey">L</span>og Entry</div>
        <div className={"newitemmenuoption cancel " + (selectedIndex === 5 ? "selected" : "")} onClick={() => { close(lastOpenedItemId); }} onMouseEnter={() => setSelectedIndex(5)}>Cancel</div>
      </div>
    </div>
  </div>;
}

export default NewItemMenu;